import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

interface StepItem {
  id: string;
  title: string;
  summary: string;
  details: string;
  icon?: string;
}

@Component({
  selector: 'app-about-sell',
  templateUrl: './about-sell.component.html',
  styleUrls: ['./about-sell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutSellComponent implements OnInit {

  steps: StepItem[] = [
    {
      id: 'step-1',
      title: 'Engin söluþóknun',
      summary: 'Fullbúið sölukerfi með engri söluþóknun',
      details:
        'Með e-fasteignum færð þú aðgang að fullbúnu sölukerfi með öllum nauðsynlegum tengingum. '
        + 'Þegar þú lýkur við söluna greiðir þú enga söluþóknun til fasteignasölu.',
      icon: 'payments'
    },
    {
      id: 'step-2',
      title: 'Söluyfirlit og skjöl',
      summary: 'Einstök skjalavirkni og aðgengi að þinglýstum skjölum',
      details:
        'Kerfið býður fullbúna virkni til að setja upp söluyfirlit. '
        + 'Öll þinglýst skjöl liggja fyrir, m.a. lán, veðbandayfirlit, fyrri kaupsamningar og afsöl. <br/>' +
        `
      <br/><strong>Kerfisvirkni fyrir sölyfirlit</strong>
      <div class="separator-line mt-2 mb-2"></div>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/soluyfirlit.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/soluyfirlit.jpg" 
               alt="Söluyfirlit" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div> <br/>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/soluyfirlit-pdf.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/soluyfirlit-pdf.jpg" 
               alt="Söluyfirlit PDF" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div> <br/>
      <strong>Kerfisvirkni fyrir þinglýst skjöl</strong>
      <div class="separator-line mt-2 mb-2"></div>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/thinglyst-skjol.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/thinglyst-skjol.jpg" 
               alt="Þinglýst skjöl" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div>
      `,
      icon: 'description'
    },
    {
      id: 'step-3',
      title: 'Ljósmyndir',
      summary: 'Þínar ljósmyndir eða fagljósmyndun',
      details:
        'Þú getur annað hvort hlaðið inn þínum eigin myndum eða fengið fagljósmyndun í gegnum samstarfsaðila e-fasteigna.'
        + `
      <br/><br/><strong>Kerfisvirkni fyrir ljósmyndir</strong>
      <div class="separator-line mt-2 mb-2"></div>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/ljosmyndir.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/ljosmyndir.jpg" 
               alt="Ljósmyndun" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div>
      `,
      icon: 'photo_camera'
    },
    {
      id: 'step-4',
      title: 'Auglýsing',
      summary: 'Fullbúin tenging við Mbl, Vísi og Fasteignaleitina',
      details:
        'Þegar undirbúningi er lokið getur þú sent auglýsinguna í birtingu á Mbl, Vísi og Fasteignaleitinni.'
        + `
      <br/><br/><strong>Kerfisvirkni fyrir auglýsingar</strong>
      <div class="separator-line mt-2 mb-2"></div>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/auglysing.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/auglysing.jpg" 
               alt="Auglýsing" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div>
      `,
      icon: 'public'
    },
    {
      id: 'step-5',
      title: 'Kauptilboðsgerð',
      summary: 'Rafræn kauptilboðsgerð með fullu gegnsæi',
      details:
        'Aðilar geta sent rafræn tilboð með upplýsingum um kaupendur, greiðslutilhögun, fyrirvörum, o.s.frv., og undirritað rafrænt. '
        + 'Þú getur í framhaldi samþykkt og undirritað, eða sent gagntilboð rafrænt.'
        + `
      <br/><br/><strong>Kerfisvirkni fyrir kauptilboð</strong>
      <div class="separator-line mt-2 mb-2"></div>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/kauptilbod.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/kauptilbod.jpg" 
               alt="Kauptilboð" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div>
      `,
      icon: 'edit_document'
    },
    {
      id: 'step-6',
      title: 'Kaupsamningur og afsal',
      summary: 'Einstök skjalavirkni fyrir kaupsamning og afsal',
      details:
        'Eftir samþykkt tilboðs er fullbúin virkni til staðar til að ganga frá kaupsamningi og afsali. '
        + 'Einnig er hægt að skrá eign án auglýsingar (t.d. ef viðskipti eiga sér stað innan fjöldskyldu eða aðilar telja ekki þörf á að auglýsa eignina til sölu) og nýta þessa virkni til að fara með skjölin í þinglýsingu. <br/><br/> Við erum stolt að segja frá því að í upphafi árs 2025 voru fyrstu skjölin úr kerfinu samþykkt af sýslumanni til þinglýsingar.'
        + `
      <br/><br/><strong>Kerfisvirkni fyrir kaupsamning og afsal</strong>
      <div class="separator-line mt-2 mb-2"></div>
      <div class="flex justify-center float-left w-100">
        <a href="/assets/images/home-page/kaupsamningur-afsal.jpg"
           target="_blank" rel="noopener noreferrer" class="inline-block">
          <img src="/assets/images/home-page/kaupsamningur-afsal.jpg" 
               alt="Kaupsamningur og afsal" 
               class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
        </a>
      </div>
      `,
      icon: 'handshake'
    },
    {
      id: 'step-7',
      title: 'Skjalafrágangur',
      summary: 'Fasteignasali getur aðstoðað við tilboðsgerð og þinglýsingu',
      details:
        'e-fasteignir eru í samstarfi við fasteignasala sem geta aðstoðað við tilboðsgerð, skjalafrágang og þinglýsingu. '
        + 'Þjónustan hentar vel ef vafi er á ákveðnum þáttum sölunnar og kostar einungis brot af hefðbundinni söluþóknun. '
        + 'Ef þú klárar ferlið sjálf(ur) fylgir kerfinu engin söluþóknun. '
        + `<p class="mt-3">
        <a href="/assets/pdf/Samningur_um_þjónustu_fasteignasala.pdf" 
           target="_blank" 
           rel="noopener noreferrer" 
           class="c-link primary-color font-semibold underline hover:no-underline">
          Skoða samstarfssamning
        </a><br/><br/>
        Samstarfssamningurinn er aðgengilegur notendum bæði við kauptilboðsgerðina og þegar kemur að kaupsamningi og/eða afsali.<br/>
        <br/><strong>Kerfisvirkni fyrir skjalafrágang</strong>
        <div class="separator-line mt-2 mb-2"></div>
        <p>Neðangreind kerfisvirkni er aðgengileg notendum þegar kemur að kauptilboði, kaupsamningi og/eða afsali:</p>
        <div class="flex justify-center float-left w-100">
          <a href="/assets/images/home-page/fasteignasali-adstod.jpg"
             target="_blank" rel="noopener noreferrer" class="inline-block">
            <img src="/assets/images/home-page/fasteignasali-adstod.jpg"
                 alt="Kaupsamningur og afsal"
                 class="my-3 rounded shadow max-h-[450px] cursor-zoom-in" />
          </a>
        </div>
      </p>`,
      icon: 'assignment_turned_in'
    }
  ];

  environment = environment;

  portalUrl = environment.portalUrl;

  constructor() { }

  ngOnInit(): void {
  }

  /** trackBy fyrir *ngFor — einkvæmt heiti */
  trackByStepIndexProperty(index: number, item: StepItem): string {
    return item.id;
  }

  /** Click handler á „Skrá fasteign“ — einkvæmt heiti */
  onRegisterPropertyClickUnique(): void {
    window.location.href = `${this.portalUrl}/skra-fasteign`;
  }
}
